import { __awaiter, __generator, __read } from "tslib";
import React, { useState, useCallback, useContext } from "react";
import { RegionExtractor } from "@shared/models/region";
import { RegionAPIContext } from "@shared/contexts/api";
import { MergeTagDialog } from "@components/common/MergeTagDialog";
import { useAppToast } from "@components/common/Toast";
export var MergeRegionDialog = React.memo(function (_a) {
    var destination = _a.destination, onDone = _a.onDone, onClose = _a.onClose;
    var regionAPI = useContext(RegionAPIContext);
    var showErrorToast = useAppToast().showErrorToast;
    var _b = __read(useState(false), 2), isMerging = _b[0], setIsMerging = _b[1];
    var onMergeTag = useCallback(function (source) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!source) {
                        return [2 /*return*/];
                    }
                    setIsMerging(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, regionAPI.mergeRegion(destination.id, { source_id: source.id })];
                case 2:
                    _a.sent();
                    onClose();
                    onDone();
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    console.error("Failed to merge tag", err_1);
                    showErrorToast({
                        titleId: "merge_tag.error.title",
                        descriptionId: "merge_tag.error.description",
                    }, {
                        position: "bottom-center",
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setIsMerging(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [regionAPI, destination.id, onClose, onDone, showErrorToast]);
    return (React.createElement(MergeTagDialog, { isOpened: true, onClose: onClose, onMergeClick: onMergeTag, destinationId: destination.id, tagName: destination.name, isMerging: isMerging, fetch: regionAPI.listRegions, keyExtractor: RegionExtractor.id, labelExtractor: RegionExtractor.name }));
});
